// import { computed, reactive, ref } from 'vue'
import store from '@/VueWorking/store.js'

// const state = reactive({
//     intId: null
// })

export default function sessionCheck() {
    const refreshSession = async (credentials) => {
        try {
            console.log(localStorage.authenticated);
            if(parseFloat(localStorage.authenticated)){
                await axios.get('/sanctum/csrf-cookie').then(async() => {
                    await axios.get('/refresh-session').then((response) => {
                        if(response.status == 200){
                            store.state.sessionTime.time = store.state.sessionTime.max;
                            console.log('refresh session')
                        } else {
                            console.log('ну блин рефреш')
                        }
                    }).catch((error) => {
                        console.log('refresh error');
                        console.log(error);
                        store.state.sessionTime.time = store.state.sessionTime.max;
                    });
                });
            } else {
                store.state.sessionTime.time = store.state.sessionTime.max;
            }
        } catch (e) {
            console.log(e);
            return Promise.reject(e.response.data.errors)
        }
    }

    // const loginSession = async () => {
    //     return attemptSession();
    // }

    // const logoutSession = async () => {
    //     return attemptSession();
    // }

    const attemptSession = async () => {
        // await axios.get('/sanctum/csrf-cookie')
        try {
            let response = await axios.get('/');
            if(response.status == 401){ throw new Error('Не авторизированны') }

            return response
        } catch (e) {
            console.log(e)
        }
    }

    return {
        // loginSession,
        // logoutSession,
        refreshSession,
        attemptSession
    }
}